import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';
import { alpha } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
  root: {
    animation: '$fadeIn 0.5s',
    background: alpha(theme.palette.graphite.main, 0.15),
    borderRadius: theme.pxToRem(4),
    fontSize: theme.pxToRem(14),
    minHeight: theme.pxToRem(35),
    padding: theme.spacing(0.125, 0.625, 0, 0.25),
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
}));

export const SequenceDetailsBox: React.FC = ({ children, ...rootProps }) => {
  const classes = useStyles({});
  return (
    <Box className={classes.root} align="center" {...rootProps}>
      {children}
    </Box>
  );
};
